










































































































import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop} from 'vue-property-decorator';

import {LoraForwarderGatewayConfiguration} from '@/model/lora/UdpPacketForwarder/LoraForwarderUdpConfig';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {},
})
export default class LoraForwarderConfiguration extends Mixins<BaseComponent>(BaseComponent) {
  @Prop(Object)
  private configuration!: LoraForwarderGatewayConfiguration;
}

